import { useLocation } from 'react-router-dom';
import AccountQueueCard from '../components/card/AccountQueueCard';

const AccountProgressLayout = ({ children }) => {
  const location = useLocation();
  const excludedPaths = ['/login', '/register', '/forgot-password'];

  const shouldShowQueue = !excludedPaths.includes(location.pathname);

  return (
    <>
      <div className="account-queue-card-container">

        {shouldShowQueue && <AccountQueueCard />}
      </div>
      {children}
    </>
  );
};

export default AccountProgressLayout;